"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileList = exports.SelectIcon = exports.handleRemove = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var handleRemove = function (props) { return function (rFile) { return function () {
    props.onChange(props.value.filter(function (cFile) { return cFile !== rFile; }));
}; }; };
exports.handleRemove = handleRemove;
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('FileList'), (0, recompose_1.defaultProps)({
    multipleFiles: false,
    uploadedFiles: {}
}), recompose_1.pure, (0, recompose_1.withHandlers)({
    handleRemove: exports.handleRemove
}));
var SelectIcon = function (props, file) {
    if (props.uploading) {
        var item = props.uploadedFiles[file.uuid];
        if (item) {
            switch (item.status) {
                case 'UPLOADING':
                    return (React.createElement("i", { key: "upload-status-icon-".concat(file.uuid, "-in-progress"), className: 'fas fa-sync-alt fa-spin in-progress' }));
                case 'UPLOADED':
                    return (React.createElement("i", { key: "upload-status-icon-".concat(file.uuid, "-complete"), className: 'fas fa-check completed' }));
                case 'FAILED':
                    return (React.createElement("span", { key: "upload-status-icon-".concat(file.uuid, "-failed"), className: 'failed' },
                        React.createElement("span", null, item.message),
                        React.createElement("i", { className: 'fas fa-exclamation-circle' })));
                case 'ERRORS':
                    return (React.createElement("i", { key: "upload-status-icon-".concat(file.uuid, "-errors"), className: 'fas fa-exclamation-triangle errors' }));
            }
        }
        return (React.createElement("i", { key: "upload-status-icon-".concat(file.uuid, "-pause"), className: 'fas fa-pause-circle' }));
    }
    return (React.createElement("i", { className: 'fas fa-times remove', onClick: props.handleRemove(file) }));
};
exports.SelectIcon = SelectIcon;
exports.FileList = enhance(function (props) { return (React.createElement("div", { className: "sok-file-upload-file-list" }, props.value.map(function (file) {
    return (React.createElement("div", { className: "sok-file-upload-file-list-item", key: "upload-row-".concat(file.uuid) },
        React.createElement("i", { className: 'fas fa-file-alt' }),
        React.createElement("span", null, file.name),
        (0, exports.SelectIcon)(props, file)));
}))); });
//# sourceMappingURL=index.js.map